var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
export const formAttributes = {
  formId: "form-id",
  teamId: "team-id",
  locale: "form-locale",
  noTrack: "notrack",
  formValues: "form-values",
  metadata: "metadata",
  accessToken: "access-token"
};
const findConfigByFormId = (formId) => {
  return window.tintForms && window.tintForms[formId] || {};
};
const getFormProperties = (form) => {
  var _a, _b, _c;
  const configValues = findConfigByFormId(form.id);
  const formProperties = {};
  for (const attributeKey in formAttributes) {
    formProperties[attributeKey] = form.getAttribute(formAttributes[attributeKey]) || configValues[attributeKey];
  }
  const onAfterLoad = ((_a = configValues == null ? void 0 : configValues.events) == null ? void 0 : _a.onAfterLoad) || null;
  const onSubmitUser = ((_b = configValues == null ? void 0 : configValues.events) == null ? void 0 : _b.onAfterSubmit) || null;
  const onBeforeSubmit = ((_c = configValues == null ? void 0 : configValues.events) == null ? void 0 : _c.onBeforeSubmit) || null;
  return __spreadProps(__spreadValues({}, formProperties), {
    locale: formProperties.locale || document.documentElement.lang,
    onAfterLoad,
    onSubmitUser,
    onBeforeSubmit
  });
};
export const FormElementPropertiesService = {
  getFormProperties
};
